//핸드폰 번호, 안심번호, 지역번호 '-' 체크 정규식
const phoneFormatter = (number) => {
  number = number.replace(/[^0-9]/g, '')

  if (number.length === 12) {
    return number.replace(/(\d{4})(\d{4})(\d{4})/, '$1-$2-$3')
  } else if (number.length === 11) {
    return number.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
  } else if (number.length === 8) {
    return number.replace(/(\d{4})(\d{4})/, '$1-$2')
  } else {
    if (number.indexOf('02') === 0) {
      return number.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')
    } else {
      return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
    }
  }
}

export { phoneFormatter }
